module.exports = __webpack_public_path__ + "img/zaixiankefu.5b2032b4.png";